/* eslint no-console:0 */

require.context('src/img', true)

// stimulus
import 'controllers/application'

// my own styles
import 'src/css/g_sign_button'
import 'src/css/creator_card_big'
import 'src/css/creator_show'
import 'src/css/creator_collage'
import 'src/css/acc_info_fields.scss'

// all styles in folder
const requireApplication = require.context('src/css/application', false, /\.(css|scss)$/)
requireApplication.keys().forEach(requireApplication)

import 'controllers'
